import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useEffect, useState } from "react";
import { addEspaceCharacters, instance } from "./config";
import styled from "@emotion/styled";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
function EvidenciaItem(changes, evidencias, setUnidades) {
  const [eTipo, setETipo] = useState({});
  const [imageUrl, setImageUrl] = useState(null);
  const [imageName, setImageName] = useState(null);
  const [eDescripcion, setEDescripcion] = useState("");
  const [extension, setExtension] = useState("");
  const [tipos, setTipos] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [file, setFile] = useState();

  const handleFileUpload = (event) => {
    if (event.target.files[0]) {
      setFile(event.target.files[0]);
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setImageUrl(reader.result);
        setImageName(file.name);
      };

      reader.readAsDataURL(file);
    }
  };
  const handleChange = () => {
    changes.evidencias[changes.changes] = {
      tipo: eTipo,
      imageUrl: imageUrl,
      imageName: imageName,
      descripcion: addEspaceCharacters(eDescripcion),
      file: file,
    };
  };
  function getTiposEvidencia() {
    instance.get("/seguimiento/listTiposEvidencia").then((res) => {
      setTipos(res.data);
    });
  }
  if (isLoading) {
    getTiposEvidencia();
    setLoading(false);
  }
  useEffect(() => {
    handleChange();
  }, [eTipo, eDescripcion, imageName, imageUrl]);
  return (
    <>
      <Box
        sx={{ display: "flex", flexDirection: "column", rowGap: "8px" }}
        padding={1}
      >
        <FormControl fullWidth>
          <InputLabel>Tipo de Archivo</InputLabel>
          <Select
    label="Age"
            onChange={(e) => {
              setExtension(
                tipos.find((tipo) => tipo.id === e.target.value).extension
              );
              setETipo(e.target.value);
            }}
          >
            {tipos.map((tipo, index) => {
              return (
                <MenuItem value={tipo.id} key={index}>
                  {tipo.nombre}
                </MenuItem>
              );
            })}
          </Select>
        </FormControl>
        {/* <input
          type="file"
          accept={extension}
          disabled={extension === ""}
          onChange={handleFileUpload}
          required
        /> */}

        <Button
          component="label"
          variant="contained"
          disabled={extension === ""}
          startIcon={<CloudUploadIcon />}
        >
          Seleccionar Archivo
          <VisuallyHiddenInput
            type="file"
            accept={extension}
            disabled={extension === ""}
            onChange={handleFileUpload}
            required
          />
        </Button>
        {imageName}
        <TextField
          margin="normal"
          required
          fullWidth
          id="descripcion"
          name="descripcion"
          label="Descripción de la evidencia"
          value={eDescripcion}
          onChange={(e) => setEDescripcion(e.target.value)}
        />
      </Box>
    </>
  );
}

export { EvidenciaItem };
